import { get, del, post, put } from 'aws-amplify/api';
import { State, StateSummary } from '../models/state.model';
import { CreateState } from '../models/state.model';
import { UpdateState } from '../models/state.model';
import type { StateAuditLogResponse } from '../models/stateAudit.model';
import { getUserToken } from './util.service';

async function stateAuthHeaders(): Promise<{ 'x-auth-token': string }> {
  const userToken = await getUserToken();
  return { 'x-auth-token': `Bearer ${userToken}` };
}

export const getStatesSummary = async (): Promise<StateSummary[]> => {
  const headers = await stateAuthHeaders();
  const response = await get({
    apiName: 'dealers',
    path: '/states?summary=true',
    options: { headers },
  }).response;

  const json = (await response.body.json()) as StateSummary[];
  return json;
};

export const getState = async (stateId: string): Promise<State> => {
  const headers = await stateAuthHeaders();
  const response = await get({
    apiName: 'dealers',
    path: `/states/${stateId}`,
    options: { headers },
  }).response;

  const json = (await response.body.json()) as State;
  return json;
};

export const createState = async (createState: CreateState): Promise<State> => {
  const headers = await stateAuthHeaders();
  const response = await post({
    apiName: 'dealers',
    path: '/states',
    options: { body: createState, headers },
  }).response;

  const json = (await response.body.json()) as State;
  return json;
};

export const updateState = async (stateId: string, updateState: UpdateState): Promise<State> => {
  const headers = await stateAuthHeaders();
  const response = await put({
    apiName: 'dealers',
    path: `/states/${stateId}`,
    options: { body: updateState, headers },
  }).response;

  const json = (await response.body.json()) as State;
  return json;
};

export const deleteState = async (stateId: string): Promise<void> => {
  const headers = await stateAuthHeaders();
  await del({
    apiName: 'dealers',
    path: `/states/${stateId}`,
    options: { headers },
  }).response;
};

export const getStateAuditLog = async (
  stateId: string,
  options?: { limit?: number; lastKey?: Record<string, unknown> },
): Promise<StateAuditLogResponse> => {
  const headers = await stateAuthHeaders();
  const params = new URLSearchParams();
  if (options?.limit !== undefined) params.set('limit', String(options.limit));
  if (options?.lastKey !== undefined) params.set('lastKey', encodeURIComponent(JSON.stringify(options.lastKey)));
  const query = params.toString();
  const path = query ? `/states/${stateId}/audit-log?${query}` : `/states/${stateId}/audit-log`;
  const response = await get({
    apiName: 'dealers',
    path,
    options: { headers },
  }).response;
  const json = (await response.body.json()) as unknown as StateAuditLogResponse;
  return json;
};
